<template>
  <div class="fixed bottom-0 right-4 z-30 flex flex-row-reverse items-end space-x-4 space-x-reverse pointer-events-none max-w-[calc(100vw-32px)] overflow-x-auto select-none">
    
    <MiniChatWindow
      v-for="partnerId in activeWindows"
      :key="partnerId"
      :partner-id="partnerId"
      :current-user-id="getUserId"
      @close="closeChatWindow"
      @maximize="maximizeChatWindow"
    />

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MiniChatWindow from './MiniChatWindow.vue';

export default {
  name: 'MiniChatManager',
  components: { MiniChatWindow },
  data() {
    return {
      // Maintains strings of conversation room IDs currently active on the tray
      activeWindows: [] 
    };
  },
  computed: {
    ...mapGetters(['getUserId', 'getActivePartnerId']),
    isMessagesPage() {
      return this.$route.path === '/messages';
    }
  },
  watch: {
    /**
     * Intercepts global navigation/interaction selections across the app.
     * If a chat is activated elsewhere, spawn it automatically inside the mini tray.
     */
    getActivePartnerId(newId) {
      if (!newId || this.isMessagesPage) return;
      this.spawnChatWindow(newId);
    },
    /**
     * Tracks full screen layout toggles to prevent overlapping view conflicts
     */
    isMessagesPage(onDedicatedPage) {
      if (onDedicatedPage) {
        // Clear mini windows when entering the full messages view to avoid UI clutter
        this.activeWindows = [];
      } else {
        // FIX: When leaving the full messages page, immediately restore 
        // the conversation they were just actively reading as a mini-window
        if (this.getActivePartnerId) {
          this.spawnChatWindow(this.getActivePartnerId);
        }
      }
    }
  },
  methods: {
    spawnChatWindow(partnerId) {
      const normalizedId = String(partnerId);
      // Guard against duplication, up to a sensible limit (e.g., max 3 active windows)
      if (!this.activeWindows.includes(normalizedId)) {
        if (this.activeWindows.length >= 3) {
          this.activeWindows.pop(); // Remove oldest tray tracking allocation
        }
        this.activeWindows.unshift(normalizedId); // Prepend new layout item to the far right
      }
    },
    closeChatWindow(partnerId) {
      this.activeWindows = this.activeWindows.filter(id => String(id) !== String(partnerId));
    },
    maximizeChatWindow(partnerId) {
      this.closeChatWindow(partnerId);
      this.$router.push({ path: '/messages', query: { id: partnerId } }).catch(() => {});
    }
  }
};
</script>